import i18next from 'i18next';

import { DO_NOT_ASSIGN_VALUE } from 'common/constants';

export const getFormattedContacts = (contacts) => {
    return contacts.map((item) => ({
        ...item,
        email: item.emails[0]?.email,
        telephone: item.telephones[0]?.telephone,
    }));
};

export const getUserOptions = (users) => {
    const items = users.map((item) => {
        return {
            label: `${item.first_name} ${item.last_name}`,
            value: item.id,
        };
    });

    return [
        {
            label: i18next.t('All text', { context: 'male', count: 2 }),
            value: '',
        },
        {
            label: i18next.t('No user assigned'),
            value: DO_NOT_ASSIGN_VALUE,
        },
        ...items,
    ];
};
